import React from 'react';
import { Profile } from '@/types/profile';
import { ProfileBasicInfoSection } from './sections/ProfileBasicInfoSection';
import { ProfileAppearanceSection } from './sections/ProfileAppearanceSection';
import { ProfileLifestyleSection } from './sections/ProfileLifestyleSection';
import { ProfileRelationshipSection } from './sections/ProfileRelationshipSection';
import { hasBasicInfo, hasAppearanceInfo, hasLifestyleInfo, hasRelationshipInfo } from '@/utils/profileSectionUtils';

interface EnhancedProfileDetailsProps {
  profile: Profile;
  currentUserInterests?: string[];
  currentUserProfile?: Profile;
}

const EnhancedProfileDetails: React.FC<EnhancedProfileDetailsProps> = ({
  profile,
  currentUserInterests = [],
  currentUserProfile
}) => {
  return (
    <div className="space-y-4">
      {/* Basic Information */}
      {hasBasicInfo(profile) && <ProfileBasicInfoSection profile={profile} />}

      {/* Physical Appearance */}
      {hasAppearanceInfo(profile) && <ProfileAppearanceSection profile={profile} />}

      {/* Lifestyle */}
      {hasLifestyleInfo(profile) && <ProfileLifestyleSection profile={profile} />}

      {/* Relationships */}
      {hasRelationshipInfo(profile) && <ProfileRelationshipSection profile={profile} />}
    </div>
  );
};

export default EnhancedProfileDetails;